import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { WorkplaceChallenges } from '../../templates';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */

class WorkplaceChallengesView extends Component {

	render () {

		const {
			heading,
			challenges,
			href,
		} = this.props.content.qrLandingPage.workplaceChallenges;

		return (

			<WorkplaceChallenges
				challenges={challenges}
				heading={heading}
				href={href}
				className='WorkplaceChallengesView'
			/>
		);
	}
}

export default withLanguageContext(WorkplaceChallengesView);



// WEBPACK FOOTER //
// ./src/components/views/WorkplaceChallengesView/WorkplaceChallengesView.js